<template>
    <Login :redirect="$route.params.redirect" @login="login" />
</template>
<script>
import Login from "./_components/Login.vue";
import api from "src/services/api.js";
import { store } from "src/global-store.js";

export default {
    name: "LoginModule",
    components: {
        Login,
    },
    computed: {
        store() {
            return store;
        },
    },
    created() {
        document.title = `Login • ${store.appName}`;
    },
    methods: {
        async login(creds, redirect) {
            try {
                const response = await api.post("/login", creds, null);
                api.storeAuthToken(response.token);

                let path = "/dashboard";
                // don't redirect back to login page
                if (redirect !== "/" && redirect !== "/login") {
                    path = redirect;
                }
                this.$router.push(path);
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>
